import { render, staticRenderFns } from "./eliminar.vue?vue&type=template&id=f6d9a2cc&scoped=true&"
import script from "./eliminar.vue?vue&type=script&lang=js&"
export * from "./eliminar.vue?vue&type=script&lang=js&"
import style0 from "./eliminar.vue?vue&type=style&index=0&id=f6d9a2cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d9a2cc",
  null
  
)

export default component.exports